<template>
  <div class="wrap">
    <b-navbar
      id="nav"
      type="dark"
      fixed="top"
      toggleable="lg"
      :class="scrollTop >= 200 || flag ? 'nav-active' : ''"
    >
      <b-container>
        <b-navbar-brand href="#/index">
          <div class="logo" style="" />
        </b-navbar-brand>
        <b-navbar-toggle
          ref="toggleBtn"
          :toggleable="false"
          @click="toggleClick"
          target="nav-collapse"
        ></b-navbar-toggle>
        <b-collapse ref="collapsePart" id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <template v-for="(item, index) in menu">
              <template v-if="item.submenu">
                <b-nav-item-dropdown
                  @click.native="navigato($event, item.path)"
                  left
                  :key="index"
                >
                  <template slot="button-content">
                    <div
                      @click="
                        linkto(
                          $event,
                          item.path,
                          screenWidth < 992 ? minScreen : ''
                        )
                      "
                    >
                      {{ getTitle(item.text) }}
                    </div>
                  </template>
                  <b-dropdown-item
                    v-for="(subItem, subIndex) in item.submenu"
                    :key="subIndex"
                    @click.stop.native="
                      linkto(
                        $event,
                        subItem.path,
                        screenWidth < 992 ? minScreen : ''
                      )"> 
                    <span
                      :style="{
                        color: subItem.color == undefined ? '' : subItem.color,
                      }"
                    >
                      {{
                        subItem.flag == undefined
                          ? getTitle(subItem.text)
                          : subItem.text
                      }}</span>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </template>
              <template v-else>
                <b-nav-item
                  :key="index"
                  :to="item.path"
                  @click="
                    linkto(
                      $event,
                      item.path,
                      screenWidth < 992 ? minScreen : ''
                    )
                  "
                  >{{ getTitle(item.text) }}</b-nav-item
                >
              </template>
            </template>
            <div class="search-flag mt-1 ml-3 mr-3">
              <div
                v-if="searchShow"
                :class="[
                  'search-input',
                  scrollTop >= 200 || flag ? 'input-fixed' : '',
                ]"
              >
                <input
                  class="sinputc"
                  type="text"
                  v-model="inputVal"
                  @keyup.enter="searchKeyWord"
                  :placeholder="$t('lang.nar_search')"
                  style="background: transparent; border: none"
                />
                <hr class="hrxian" />
                <b-icon icon="search" variant="light"></b-icon>
              </div>
              <b-icon icon="search" variant="light"></b-icon>
            </div>
            <b-nav-item @click="changeLanguage">{{
              $t("lang.lang")
            }}</b-nav-item>

            <div
              class="mini-input"
              :class="screenWidth > 992 ? 'mini-input' : ' H5input'"
            >
              <input
                type="text"
                v-model="inputVal"
                @change="searchKeyWord"
                @keyup.enter="searchKeyWord"
                :placeholder="
                  screenWidth > 992 ? $t('lang.nar_search') : 'SEARCH'
                "
                style="
                  background: transparent;
                  border: none;
                  padding: 0.5rem 0.5rem;
                  width: 100%;
                "
              />
              <b-icon
                icon="search"
                variant="light"
                style="margin-right: 0.5rem"
              ></b-icon>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <banner></banner>
    <router-view />
  </div>
</template>
<script>
export default {
  inject: ["reload"], //注入reload方法
  data() {
    return {
      toggleAttr: {},
      scrollTop: 0,
      screenWidth: document.body.clientWidth,
      searchShow: false,
      flag: false,
      inputVal: "",
      menu: [
        {
          text: "home",
          path: "/index",
        },
        {
          text: "laureates",
          path: "/laureates/list?listBy=year",
          submenu: [
            {
              // text: '按年份',
              text: "YEAR",
              path: "/laureates/list?listBy=year",
            },
            {
              // text: '按奖项',
              text: "AWARDS",
              path: "/laureates/list?listBy=prize",
            },
            {
              // text: '按姓氏首字母',
              text: "WINNERS",
              path: "/laureates/list?listBy=letter",
            },
          ],
        },
        {
          text: "nomination",
          path: "/nomination",
          submenu: [
            {
              // text: '奖项',
              text: "menuPrize",
              path: "/nomination/list",
            },
            // {
            // 	// text: '生命科学奖',
            // 	text: 'Lifescienceprize',
            // 	path: '/nomination/award-rule?type=1',
            // },
            // {
            // 	// text: '物质科学奖',
            // 	text: 'Physicalscienceprize',
            // 	path: '/nomination/award-rule?type=2',
            // },
            // {
            // 	// text: '数学与计算机科学奖',
            // 	text: 'MCprize',
            // 	path: '/nomination/award-rule?type=3',
            // },
          ],
        },
        {
          text: "donors",
          path: "/donors/list",
        },
        {
          text: "news",
          path: "/news/list?tab=0&type=0",
          submenu: [
            {
              // text: '公告',
              text: "mununotice",
              path: "/news/list?tab=1&type=1",
            },
            // {
            // 	// text: '新闻资讯',
            // 	text: 'PressConference',
            // 	path: '/news/list?type=2',
            // },
            // {
            // 	// text: '获奖人专访',
            // 	text: 'IwithL',
            // 	path: '/news/list?type=3',
            // },
            // {
            // 	// text: '更多',
            // 	text: 'NandI',
            // 	path: '/news/list?type=4',
            // },
          ],
        },
        {
          text: "events",
          // path: '/activity/list',
          submenu: [
            // {
            // 	// text: '2020未来科学大奖周',
            // 	text: 'FSPW2020',
            // 	path: '/prizeweek/index?year=2020',
            // },
            // {
            // 	// text: '2019年未来科学大奖周',
            // 	text: 'FSPW2019',
            // 	path: '/prizeweek/index?year=2019',
            // },
            // {
            // 	// text: '颁奖典礼',
            // 	text: 'Awardceremony',
            // 	path: '/activity/list?type=1',
            // },
            // {
            // 	// text: '获奖人学术报告会',
            // 	text: 'Laureateslecture',
            // 	path: '/activity/list?type=2',
            // },
            // {
            // 	// text: '科学峰会',
            // 	text: 'Symposium',
            // 	path: '/activity/list?type=3',
            // },
            // {
            // 	// text: '青少年对话获奖人',
            // 	text: 'Inspirationinitiative',
            // 	path: '/activity/list?type=4',
            // },
          ],
        },
        {
          text: "awardabout",
          path: "/about/structure",
          submenu: [
            {
              // text: '未来科学大奖概述',
              text: "aboutFSP",
              path: "/about/structure",
            },
            {
              // text: '章程',
              text: "Bylaw",
              path: "/about/regulations",
            },
            {
              // text: '科学委员会',
              text: "Sciencecommittee",
              path: "/about/science",
            },
            {
              // text: '监督委员会',
              text: "Supervisorycommittee",
              path: "/about/oversight",
            },
            {
              // text: '联系我们',
              text: "Contactus",
              path: "/about/contact",
            },
          ],
        },
        {
          text: "future",
          path: "/forum",
        },
      ],
      langFlag: false,
    };
  },
  computed: {
    //监听 全局变量screenWidth
    listebScreenWidth() {
      return this.$store.state.screenWidth;
    },
  },
  watch: {
    listebScreenWidth(val) {
      this.screenWidth = val;
    },
  },
  created() {
    localStorage.getItem("LANG") == "cn" || !localStorage.getItem("LANG")
      ? ((this.$i18n.locale = "cn"), (this.langFlag = false))
      : ((this.$i18n.locale = "en"), (this.langFlag = true));
    this.getBigAwardYearId();
    this.getAwardsList();
    this.getTabData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    document.addEventListener("click", (e) => {
      if (
        e.target.className.baseVal == "bi-search b-icon bi text-light" ||
        e.target.className == "sinputc"
      ) {
        this.searchShow = true;
      } else {
        this.searchShow = false;
      }
    });
    // if (this.$i18n.locale == 'en' && this.screenWidth > 992) {
    // 	let arr = document.getElementsByClassName('nav-link')
    // 	arr.forEach((item) => {
    // 		item.style.padding = '0'
    // 	})
    // }
  },
  destroyed() {
    this.langFlag
      ? localStorage.setItem("LANG", "en")
      : localStorage.setItem("LANG", "cn");
  },
  methods: {
    //资讯下拉菜单
    getTabData() {
      this.$api.newsCategory().then((res) => {
        let arr = res.data.map((item, index) => {
          return {
            flag: true,
            text: item.name,
            path: `/news/list?tab=${index + 2}&type=${item.id}`,
          };
        });
        this.menu[4].submenu.push(...arr);
      });
    },
    //奖项下拉菜单
    getAwardsList() {
      this.$api.awardsList().then((res) => {
        let newArr = res.data.map((item) => {
          return {
            flag: true,
            text: item.name,
            path: "/nomination/award-rule?type=" + item.id,
          };
        });
        this.menu[2].submenu.push(...newArr);
      });
    },
    //获取大奖周下拉表
    getBigAwardYearId() {
      this.$api.getBigAwardYearId().then((res) => {
        let arr = res.data;
        let newArr = arr.map((item, index) => {
          return {
            flag: true,
            text: item.name,
            path: `/prizeweek/oldVersion?year=${item.id}&index=${index}`,
            color: "#cfaf75",
          };
        });
        newArr[0].path = `/prizeweek/index?year=${arr[0].id}&index=0`;
        this.menu[5].submenu.push(...newArr);
        this.getActivityFirList();
      });
    },
    //搜索关键字
    searchKeyWord(e) {
      this.$api
        .newsSearch({
          page: 1,
          limit: 10000,
          title: this.inputVal,
        })
        .then((res) => {
          const newRoute = this.$router.resolve({
            path: "/search/index",
            query: { searchword: this.inputVal },
          });
          localStorage.setItem(
            "SEARCH_CONTENT",
            JSON.stringify(res.data.records)
          );
          window.open(newRoute.href, "_blank");
        });
    },

    //活动一级分类下拉
    getActivityFirList() {
      this.$api.activityFirList().then((res) => {
        let arr = res.data;
        this.menu[5].path = `/activity/list?type=${arr[0].id}&tit=${arr[0].name}`;
        let newArr = arr.map((item) => {
          return {
            text: item.name,
            flag: true,
            path: `/activity/list?type=${item.id}&tit=${item.name}`,
          };
        });
        this.menu[5].submenu.push(...newArr);
      });
    },
    getTitle(title) {
      //中英文切换
      let str = "lang." + title;
      return this.$t(str);
    },
    search() {
      this.searchShow = !this.searchShow;
      console.log("搜索");
    },
    changeLanguage() {
      this.flag = !this.flag;
      this.langFlag = !this.langFlag;
      if (this.langFlag) {
        localStorage.setItem("LANG", "en");
      } else {
        localStorage.setItem("LANG", "cn");
      }
      this.$router.push("/");
      this.reload(); //刷新
    },
    handleScroll() {
      this.scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      // console.log(this.scrollTop)
    },
    navigato(e, path) {
      // this.flag = !this.flag
      // console.log('eeeeeeeeeeeee---------',e)
      this.$router.push(path);
    },
    linkto(e, path, fn) {
      fn ? fn() : "";
      this.$router.push(path);
    },
    //h5端的单行栏适配
    minScreen() {
      this.$refs.collapsePart.toggle();
      this.flag = !this.flag;
    },
    toggleClick(e) {
      this.flag = !this.flag;
    },
  },
};
</script>
<style lang="scss" scoped>
#nav {
  padding: 1rem;
  width: 100vw;
}
.logo {
  width: 8rem;
  height: 2rem;
  margin: 4px 6px;
  background: url("http://www.futureprize.org/resource/data/uploads/30/1a98888a670638c562deabfd705a4e3f.png")
    no-repeat;
  background-size: 100% 145%;
}
.search-input {
  display: flex;
  align-items: center;
  position: absolute;
  top: 3rem;
  right: -1rem;
  height: 2rem;
  line-height: 2rem;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 0 1rem;
  font-size: 1rem;
}

.mini-input {
  margin-top: 2rem;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  border-radius: 0.4rem;
}
.H5input {
  margin: 1.5rem 5px 0rem 5px;
  border: 1px solid #8d8d8d;
  input::-webkit-input-placeholder {
    color: #8d8d8d;
  }
  input::-moz-input-placeholder {
    color: #8d8d8d;
  }
  input::-ms-input-placeholder {
    color: #8d8d8d;
  }
}
.search-flag {
  position: relative;
  display: none;
  font-size: 1.2rem;
}

.input-fixed {
  top: 0rem;
  right: -1rem;
  background: #000;
}

input {
  color: #fff;
}

.nav-active {
  background: #000;
}

input::-webkit-input-placeholder {
  color: #fff;
}
.nav-active {
  background: #000 !important;
}
.hrxian {
  z-index: 999;
  width: 0.1rem;
  position: relative;
  left: -0.6rem;
  background: #eee9e9;
  height: 1rem;
}
.wrap::v-deep {
  .navbar {
    display: block;
  }

  .navbar-dark .navbar-toggler {
    color: #ffffff;
    border: none;
  }

  .dropdown-toggle::after {
    pointer-events: auto;
    display: inline-block;
    border: none;
    width: 1.2rem;
    height: 1.2rem;
    background: url("../assets/down-arrow.png") center no-repeat;
    background-size: 100%;
    z-index: 99999;
  }
  .dropdown-toggle:hover::after{
    transform: rotate(180deg);
  }

  .dropdown-toggle:focus::after{
    transform: rotate(0deg);
  }

  

  .navbar-collapse.show {
    height: 100vh;
  }

  .dropdown > .dropdown-menu {
    border-radius: 0;
    background-color: #000;
  }
  .dropdown-item {
    padding: 0.6rem 2rem;
    color: #666666;
  }

  .dropdown-item:focus {
    color: #cfaf75 !important;
    background-color: #ffffff !important;
  }
  .navbar-dark .navbar-nav .nav-link {
    color: #ffffff !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transform: scale(0.9);
  }

  .navbar-nav {
    margin-top: 1rem;
    .nav-item {
      padding: 5px 0rem 0rem 0rem;
    }
  }
}
@media (min-width: 992px) {
  .wrap::v-deep {
    .navbar-collapse.show {
      height: 0;
    }
    .logo {
      width: 12rem;
      height: 2.4rem;
    }
    .search-flag {
      display: inline;
      /* visibility: visible; */
    }
    .mini-input {
      display: none;
    }
    .navbar-nav {
      margin-top: unset;
    }
    .dropdown:hover > .dropdown-menu {
      display: block;
      left: 0.8rem;
      background-color: #fff;
    }

    .dropdown > .dropdown-toggle:active {
      pointer-events: none;
    }
    .dropdown > .dropdown-toggle::after {
      border: none;
    }
    .navbar-expand-lg .navbar-nav .nav-link {
      padding-right: 1rem !important;
      padding-left: 1rem;
    }
    .dropdown-toggle::after {
      display: none;
    }
    .dropdown-toggle:focus::after {
      pointer-events: none;
    }
    .dropdown-item {
      padding: 0.6rem 1rem;
      color: #666666;
    }
    .dropdown-item:hover {
      background: none;
      color: $science-theme-color;
    }
    .navbar-nav {
      align-items: center;
      .nav-item {
        width: max-content;
        padding: 0 0 0 0;
      }
    }
    .navbar-dark .navbar-nav .nav-link:hover {
      color: $science-theme-color !important;
    }
  }
}
</style>
